import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "sonner";
import ComingSoon from "./pages/ComingSoon";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Journal from "./pages/Journal";
import Studio from "./pages/Studio";
import Story from "./pages/Story";
import Home from "./pages/Home";
import ToolkitViewer from "./pages/ToolkitViewer";
import SoundtrackViewer from "./pages/SoundtrackViewer";
import SoundtrackPreview from "./pages/SoundtrackPreview";
import AdminSoundtrack from "./pages/AdminSoundtrack";
import SharedToolkit from "./pages/SharedToolkit";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import OrderSuccess from "./pages/OrderSuccess";
import OrderCancel from "./pages/OrderCancel";
import AdminSessions from "./pages/AdminSessions";
import AdminSales from "./pages/AdminSales";
import ReviewPage from "./pages/ReviewPage";
import RedeemGift from "./pages/RedeemGift";
import RateToolkits from "./pages/RateToolkits";
import BookSession from "./pages/BookSession";
import MilestoneBanner from "./components/MilestoneBanner";
import MilestoneCelebration from "./components/MilestoneCelebration";
import Nav from "./components/Nav";
import Footer from "./components/Footer";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="p-12 text-center text-teal-200/70">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const AuthedShell = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  const triggerKey = user ? `${user.id}:${location.pathname}` : "guest";
  return (
    <>
      <Nav />
      {children}
      <MilestoneBanner />
      <MilestoneCelebration authed={!!user} triggerKey={triggerKey} />
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route path="/" element={<ComingSoon />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/order/success" element={<OrderSuccess />} />
            <Route path="/order/cancel" element={<OrderCancel />} />
            <Route path="/review/:token" element={<ReviewPage />} />
            <Route path="/redeem/:code" element={<RedeemGift />} />
            <Route path="/rate/:token" element={<RateToolkits />} />
            <Route path="/book" element={<BookSession />} />
            <Route path="/share/:token" element={<SharedToolkit />} />

            {/* App */}
            <Route path="/home" element={<AuthedShell><Home /></AuthedShell>} />
            <Route path="/story" element={<AuthedShell><Story /></AuthedShell>} />
            <Route path="/studio" element={<AuthedShell><Studio /></AuthedShell>} />
            <Route path="/dashboard" element={<Protected><AuthedShell><Dashboard /></AuthedShell></Protected>} />
            <Route path="/journal" element={<Protected><AuthedShell><Journal /></AuthedShell></Protected>} />
            <Route path="/toolkit/:id" element={<Protected><AuthedShell><ToolkitViewer /></AuthedShell></Protected>} />
            <Route path="/soundtrack" element={<Protected><AuthedShell><SoundtrackViewer /></AuthedShell></Protected>} />
            <Route path="/soundtrack/preview" element={<AuthedShell><SoundtrackPreview /></AuthedShell>} />
            <Route path="/admin/soundtrack" element={<Protected><AuthedShell><AdminSoundtrack /></AuthedShell></Protected>} />
            <Route path="/admin/sessions" element={<Protected><AuthedShell><AdminSessions /></AuthedShell></Protected>} />
            <Route path="/admin/sales" element={<Protected><AuthedShell><AdminSales /></AuthedShell></Protected>} />
            <Route path="/payment/success" element={<Protected><AuthedShell><PaymentSuccess /></AuthedShell></Protected>} />
            <Route path="/payment/cancel" element={<Protected><AuthedShell><PaymentCancel /></AuthedShell></Protected>} />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster theme="dark" position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
